module.exports = __webpack_public_path__ + "static/bane_lord_of_darkness_2-ae0ee227054e5a25f03d89a3e3db3e38.webp";